type Variant = "new" | "bestseller" | "limited" | "restock"

const styles: Record<Variant, string> = {
  new: "bg-[#1A1612] text-[#FFFFFF]",
  bestseller: "bg-[#B0813A] text-white",
  limited: "bg-[#5C6B53] text-white",
  restock: "bg-white text-[#1A1612] border border-[#1A1612]",
}

const labels: Record<Variant, string> = {
  new: "New",
  bestseller: "Bestseller",
  limited: "Limited",
  restock: "Restock",
}

type Props = { variant: Variant; className?: string }

export default function ColBadge({ variant, className = "" }: Props) {
  return (
    <span
      className={`inline-block px-[9px] py-[5px] font-sans text-[8px] uppercase leading-none tracking-[2px] ${styles[variant]} ${className}`}
    >
      {labels[variant]}
    </span>
  )
}
